export default __webpack_public_path__ + "updated-on.svg";